export default __webpack_public_path__ + "static/media/matic-token-icon.765bd4b7.svg";